const DriverAgreementFlow = {
  REDIRECT: "REDIRECT",
  INTEGRATED: "INTEGRATED",
} as const;

type DriverAgreementFlow =
  (typeof DriverAgreementFlow)[keyof typeof DriverAgreementFlow];

export default DriverAgreementFlow;
export type { DriverAgreementFlow };
